import helpers from "../../../_helpers/helpersFunction";

export default {
    getSessionFromBackend,
    chargeUser
}


async function getSessionFromBackend(dati) {
     return await fetch(process.env.REACT_APP_PAY+"/orders/applePay/startSession",{ 
          method: 'post', 
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dati)
        })
        .then(res => res.json())
        .then(response => {
          return response
        })
        .catch((err)=>{
            helpers.logToBackend("ApplePay",{clickid:dati.clickid,error:err.message})
        })
}



async function chargeUser(dati) {
     return await fetch(process.env.REACT_APP_PAY+"/orders/applePay/chargeUser",{ 
          method: 'post', 
          headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dati)
        })
        .then(res => res.json())
        .then(response => {
          return response
        })
        .catch((err)=>{
            helpers.logToBackend("ApplePay",{clickid:dati.clickid,error:err.message})
        })
}
